import(/* webpackMode: "eager" */ "/app/packages/private-widget/src/app/error.tsx");
